import { render, staticRenderFns } from "./BirthDateSelectInputGroup.vue?vue&type=template&id=3ab59fb7&scoped=true&"
import script from "./BirthDateSelectInputGroup.vue?vue&type=script&lang=ts&"
export * from "./BirthDateSelectInputGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab59fb7",
  null
  
)

export default component.exports